// extracted by mini-css-extract-plugin
export default {"policy":"Policies_policy__7S87p","policyButton":"Policies_policyButton__buZpx","arrowIcon":"Policies_arrowIcon__Xw88a"};